module.exports = __webpack_public_path__ + "img/Logo-MS_Horizontal-2.3100feac.png";